@if (mode === 'prompt') {
    <div class="modal-header">
        <h5 class="modal-title">Location Required</h5>
    </div>
    <div class="modal-body">
        <p>
            Location sharing is
            <strong>required</strong>
            to record dispense events. Your device's coordinates are captured at
            the time you submit a dispense event so we know where the refueling
            took place.
        </p>
        <p>
            Tap
            <strong>Enable Location</strong>
            below, then choose
            <strong>Allow</strong>
            when your browser or phone asks for permission.
        </p>
    </div>
    <div class="modal-footer">
        <button
            type="button"
            class="btn btn-cancel btn-lg"
            (click)="deny()"
        >
            Not Now
        </button>
        <button
            type="button"
            class="btn btn-save btn-lg"
            (click)="accept()"
        >
            Enable Location
        </button>
    </div>
} @else {
    <div class="modal-header">
        <h5 class="modal-title">Location Is Blocked</h5>
    </div>
    <div class="modal-body">
        <p>
            Location sharing is
            <strong>required</strong>
            to create dispense events, but it is currently blocked for this app.
            Re-enable it in your settings, then return here:
        </p>
        <ul>
            <li>
                <strong>iPhone / iPad:</strong>
                Settings &rsaquo; Privacy &amp; Security &rsaquo; Location
                Services &rsaquo; turn on for your browser, then reload.
            </li>
            <li>
                <strong>Android (Chrome):</strong>
                tap the lock / settings icon in the address bar &rsaquo;
                Permissions &rsaquo; Location &rsaquo; Allow.
            </li>
            <li>
                <strong>Desktop:</strong>
                click the lock / site-info icon in the address bar &rsaquo;
                Location &rsaquo; Allow, then reload the page.
            </li>
        </ul>
    </div>
    <div class="modal-footer">
        <button
            type="button"
            class="btn btn-save btn-lg"
            (click)="close()"
        >
            OK
        </button>
    </div>
}
